import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import router from "./router";
import VueBus from "vue-bus";
import axios from "axios";
import VueAxios from "vue-axios";
import Snotify, { SnotifyPosition } from "vue-snotify";
import "vue-snotify/styles/material.css";
import VueCodemirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import VueProgress from "vue-progress-path";
import "vue-progress-path/dist/vue-progress-path.css";

import Default from "./layouts/Default";
import NoSideBar from "./layouts/NoSideBar";

Vue.component("default-layout", Default);
Vue.component("no-sidebar-layout", NoSideBar);

import store from "./store";

window.axios = axios;
axios.defaults.baseURL = "https://sureclaims.co:8002/api";
axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("AUTH_TOKEN");

const snotifyOptions = {
  toast: {
    timeout: 3000,
    showProgressBar: true,
    position: SnotifyPosition.rightTop,
  },
};

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(Snotify, snotifyOptions);
Vue.use(VueCodemirror);

Vue.use(VueProgress, {
  // defaultShape: 'circle',
});
Vue.use(VueBus);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
